import { useTracks, VideoTrack } from '@livekit/components-react';
import { Track } from 'livekit-client';

// ---------------------------------------------------------------------------
// ParticipantView — grid of remote participant camera tiles.
// Local participant is excluded (shown separately in SelfView).
// ---------------------------------------------------------------------------
export default function ParticipantView() {
  const tracks = useTracks(
    [{ source: Track.Source.Camera, withPlaceholder: true }],
    { onlySubscribed: false },
  );

  // Exclude local participant — they appear in SelfView
  const remoteTracks = tracks.filter((t) => !t.participant.isLocal);

  if (remoteTracks.length === 0) {
    return (
      <div className="lk-no-participants">
        <p>Waiting for others to join…</p>
      </div>
    );
  }

  return (
    <div className={`lk-participant-grid lk-participant-grid--${Math.min(remoteTracks.length, 4)}`}>
      {remoteTracks.map((trackRef) => {
        const { participant, publication } = trackRef;
        const hasVideo = publication?.track && !publication.isMuted;
        const initials = (participant.name || participant.identity || '?')
          .split(' ')
          .map((w) => w[0])
          .join('')
          .slice(0, 2)
          .toUpperCase();

        return (
          <div key={participant.identity} className="lk-participant-tile">
            {hasVideo ? (
              <VideoTrack trackRef={trackRef} className="lk-participant-video" />
            ) : (
              <div className="lk-avatar-placeholder">
                <span className="lk-avatar-initials">{initials}</span>
              </div>
            )}
            <p className="lk-participant-name">
              {participant.name || participant.identity}
            </p>
          </div>
        );
      })}
    </div>
  );
}
